package com.karyadina.config

import org.jetbrains.compose.resources.DrawableResource
import com.karyadina.common.generated.resources.Res
import com.karyadina.common.generated.resources.qr_code_bhim_upi
import com.karyadina.common.generated.resources.qr_code_buymecoffe
import com.karyadina.common.generated.resources.qrcode_ko_fi

/**
 * Single source of truth for all donation-related configuration.
 * You can easily update URLs, UPI IDs, and toggle features from here.
 */
object DonationConfig {
    
    // --- URLs and IDs ---
    
    // Replace with your actual UPI ID and Name
    const val UPI_ID = "aagapaisa@upi"
    const val UPI_NAME = "NOne"
    
    // The constructed UPI intent URL
    val upiIntentUrl: String
        get() = "upi://pay?pa=$UPI_ID&pn=$UPI_NAME&cu=INR"
        
    // Replace with your actual URLs
    const val BUY_ME_A_COFFEE_URL = "https://buymeacoffee.com/karyadina"
    const val KO_FI_URL = "https://ko-fi.com/karyadina_kridaprema"
    
    // --- QR Code Configuration ---
    
    data class QrCodeOption(
        val title: String,
        val imageRes: DrawableResource
    )
    
    // List of available QR codes to display in the expandable section
    val availableQrCodes = listOf(
        QrCodeOption("UPI (India)", Res.drawable.qr_code_bhim_upi),
        // QrCodeOption("Buy Me a Coffee", Res.drawable.qr_code_buymecoffe), // Disabled per request
        QrCodeOption("Ko-fi", Res.drawable.qrcode_ko_fi)
    )
}
